import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="turbo-redirect"
export default class extends Controller {
  connect() {
    document.addEventListener("turbo:before-stream-render", function (event) {
      const action = event.target.getAttribute("action");
      if (action === "redirect") {
        const url = event.target.getAttribute("url");
        window.location = url;
        event.preventDefault();
      }
    });
  }
}
